import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ShoppingBag, BookOpen, ExternalLink } from 'lucide-react';
import { PageTransition, FadeInItem } from '@/components/motion/Animations';

const PRODUCTS = [
  {
    id: 'book-reconstruindo',
    name: 'Reconstruindo Caminhos',
    type: 'Livro',
    description: 'Guia prático baseado na filosofia da Enantiodromia para familiares e pessoas em recuperação.',
    image: null,
    icon: BookOpen,
    color: 'text-amber-600',
    bg: 'bg-amber-100 dark:bg-amber-900/30',
    available: true,
    links: [
      { label: 'Amazon', url: 'https://amazon.com/dp/B0F6P16L19', color: 'bg-amber-500 hover:bg-amber-600' },
      { label: 'Hotmart', url: 'https://go.hotmart.com/J97516427X?dp=1', color: 'bg-emerald-500 hover:bg-emerald-600' },
    ],
  },
];

export function Shop() {
  return (
    <PageTransition>
      <div className="max-w-4xl mx-auto" data-testid="shop-page">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <ShoppingBag className="h-7 w-7 text-primary" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-bold mb-1">Loja U-Clean</h1>
          <p className="text-sm text-muted-foreground">Materiais de apoio para sua jornada</p>
        </div>

        {/* Products */}
        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          {PRODUCTS.map((product, i) => (
            <FadeInItem key={product.id} index={i}>
              <ProductCard product={product} />
            </FadeInItem>
          ))}
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground/50">
          Novos produtos em breve. Fique ligado!
        </p>
      </div>
    </PageTransition>
  );
}

function ProductCard({ product }) {
  const Icon = product.icon;

  return (
    <Card className="rounded-2xl border-border/40 shadow-sm hover:shadow-md transition-all overflow-hidden" data-testid={`product-card-${product.id}`}>
      {/* Image/Illustration area */}
      <div className={`h-40 ${product.bg} flex items-center justify-center`}>
        <Icon className={`h-16 w-16 ${product.color} opacity-40`} strokeWidth={1} />
      </div>

      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <h3 className="font-bold">{product.name}</h3>
          <Badge variant="secondary" className="text-[10px] rounded-md">{product.type}</Badge>
        </div>

        <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
          {product.description}
        </p>

        <div className="flex gap-2">
          {product.links.map((link) => (
            <Button
              key={link.label}
              onClick={() => window.open(link.url, '_blank')}
              size="sm"
              className={`rounded-xl flex-1 gap-1.5 text-white ${link.color}`}
              data-testid={`buy-${link.label.toLowerCase()}-btn`}
            >
              <ExternalLink className="h-3.5 w-3.5" />
              {link.label}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
